import type { Company } from "@/services/api/companies";
import { CompaniesTableHeader } from "./CompaniesTableHeader";
import { CompaniesTableRow } from "./CompaniesTableRow";

interface CompaniesTableProps {
  companies: Company[];
  sortColumn?: string;
  sortDirection?: "asc" | "desc";
  onSort: (column: string) => void;
  onToggleStatus: (company: Company) => void;
  onEdit: (company: Company) => void;
  isUpdating?: boolean;
}

export function CompaniesTable({
  companies,
  sortColumn,
  sortDirection,
  onSort,
  onToggleStatus,
  onEdit,
  isUpdating = false,
}: CompaniesTableProps) {
  if (companies.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-ink-500">
        No companies found.
      </div>
    );
  }

  return (
    <div className="max-h-[calc(75vh-1.5rem)] overflow-auto pb-12">
      <table className="w-full">
        <CompaniesTableHeader
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <tbody className="divide-y divide-grid-200">
          {companies.map((company) => (
            <CompaniesTableRow
              key={company.id}
              company={company}
              onToggleStatus={onToggleStatus}
              onEdit={onEdit}
              isUpdating={isUpdating}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
